import {mapGetters} from "vuex";

export default {
    name: 'overlay',
    props: {
        item: {
            type: Object,
default: () => ({ phones: [], emails: [], instagram: '', facebook: '', address: '', map_link: '' })        },
        menu: {
            type: Array,
            default: () => []
        }
        ,
    },
    computed: {
        ...mapGetters({
           burgerMenu:'home/menuContent',
            contactsContent: 'home/contactsContent',
        }),
        isLogout() {
            return localStorage.getItem('user_token')
        }
    },
    methods: {
        toggleOverlay: function () {
            const overlay = document.querySelector('.overlay')
            overlay.classList.toggle('open')
        },
        toggleBurger: function () {
            const burgerDeluxe = document.getElementById('burger_deluxe')
            burgerDeluxe.classList.toggle('open')
        },
        scrollTop: function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
}
